import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
Object.defineProperties(Vue.prototype, {
  $date: {
    get() {
      return dayjs
    }
  }
})